import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';

const Superadmin = () => {
  const navigate = useNavigate();

  const cards = [
    { title: 'Users Management', icon: 'fas fa-user', path: '/super-admin/users' },
    { title: 'Products Management', icon: 'fas fa-box', path: '/super-admin/products' },
    { title: 'Orders Management', icon: 'fas fa-box', path: '/super-admin/orders' },
    { title: 'Category Management', icon: 'fas fa-tags', path: '/super-admin/categories' },
    { title: 'Subcategories Management', icon: 'fas fa-list', path: '/super-admin/subcategories' },
    { title: 'Category Attributes Management', icon: 'fas fa-tags', path: '/super-admin/category-attributes' },
    { title: 'Subcategory Attributes Management', icon: 'fas fa-layer-group', path: '/super-admin/subcategory-attributes' },
    { title: 'Category Attributes Value Management', icon: 'fas fa-cubes', path: '/super-admin/product-category-attribute-value' },
    { title: 'Subcategory Attributes Value Management', icon: 'fas fa-cube', path: '/super-admin/product-subcategory-attribute-value' }
  ];

  return (
    <div className="flex min-h-screen relative">
    <div className="z-50">
      <Sidebar />
    </div>
  
    <div className="flex-grow bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-100 p-6 lg:ml-64">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden flex flex-col justify-between h-full"
            >
              <div className="p-6 flex-grow">
                <h2 className="text-xl font-semibold mb-6">{card.title}</h2>
              </div>
              <div className="p-6">
                <button
                  className="flex items-center justify-center w-full py-3 px-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 dark:bg-blue-600 dark:hover:bg-blue-700 transition-colors"
                  onClick={() => navigate(card.path)}
                >
                  <i className={`${card.icon} mr-2`}></i> Manage {card.title.split(" ")[0]}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
  
  );
};

export default Superadmin;
